



























































import { Component, Watch, Vue, Emit } from 'vue-property-decorator';
import { patrolManagementServe } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';

@Component({
  mixins: [TableStripe],
})
export default class PatrolVerifyEdit extends Vue {
  private visible = false;
  private type = '';
  private verifyId = '';
  private form: any = {
    loading: false,
    status: '',
    auditOpinion: '',
  };
  private formDataRule: any = {
    status: [{ required: true, message: '请进行审核', trigger: ['blur', 'change'] }],
    auditOpinion: [{ required: true, message: '请填写审核意见', trigger: 'blur' }],
  };
  private verifyData: any = {};
  private _showOnce = false;

  /**
   * 打开编辑窗口
   * @Params
   * @return
   **/
  async showEditDialog(id: string) {
    this.form.loading = true;
    this.type = 'edit';
    this.verifyId = id;
    try {
      this.visible = true;
      await this.handleShowOnce();
      await this.getVerifyData(id);
    } catch (e) {}
  }
  /**
   * 处理首次打开窗口
   */
  async handleShowOnce() {
    if (this._showOnce) return;
    this._showOnce = true;
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      this.editVerifyData();
    });
  }

  /**
   *【接口】获取申请详情
   * @Params
   * @return
   **/
  async getVerifyData(id: string) {
    this.form.loading = true;
    const res: any = await patrolManagementServe.getPatrolVerifyInfoData(id);
    if (res.code === '200') {
      this.verifyData = res.data;
      this.form.loading = false;
    }
  }

  /**
   *【接口】编辑
   * @Params
   * @return
   **/
  async editVerifyData() {
    const taskPointIds: any = this.verifyData.taskPointList && this.verifyData.taskPointList.length ? this.verifyData.taskPointList.map((item: any) => item.id) : [];
    try {
      const res: any = await patrolManagementServe.editPatrolVerifyListData(this.verifyId, {
        taskId: this.verifyData.taskId,
        taskPointIds: taskPointIds,
        applicantId: this.verifyData.applicantId,
        reasonApplication: this.verifyData.reasonApplication,
        auditOpinion: this.form.auditOpinion,
        status: this.form.status,
      });
      if (res.code == 201) {
        this.$message.success('审核成功。');
        this.hideDialog();
      } else {
        this.$message.warning(res.msg);
        throw new Error();
      }
    } catch (e) {
      console.log(e);
      throw new Error();
    }
  }

  /**
   * 关闭窗口
   * @Params
   * @return
   **/
  hideDialog() {
    this.verifyData = {};
    this.form = {
      loading: false,
      status: '',
      auditOpinion: '',
    };
    this.visible = false;
    this.$emit('on-response');
  }
}
